import { render, staticRenderFns } from "./MultiselectIcon.vue?vue&type=template&id=3de50584&"
import script from "./MultiselectIcon.vue?vue&type=script&lang=js&"
export * from "./MultiselectIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports